import React from "react";
import { AdsSlotProps } from "./Ads.Slot";
import AdsSlotEngine from "./Ads.Slot.Engine";

const urlMapRegex = {
  "/$": "home",
  "^/cbn-goiania/boca-baco.*": "boca-baco",
  "^/cbn-goiania/cafe-com-cbn.*": "cafe-com-cbn",
  "^/cbn-goiania/cbn-talk.*": "cbn-talk",
  "^/cbn-goiania/cenario-economico.*": "cenario-economico",
  "^/cbn-goiania/empreender.*": "empreender",
  "^/cbn-goiania/guia-saude.*": "guia-saude",
  "^/cbn-goiania/napontadalingua.*": "napontadalingua",
  "^/cbn-goiania/papo-politico.*": "papo-politico",
  "^/cbn-goiania/plural.*": "plural",
  "^/cbn-goiania/proseando.*": "proseando",
  "^/cbn-goiania/radio-pet.*": "radio-pet",
  "^/tarde-cbn/diva-na-cbn.*": "diva-na-cbn",
  "^/tarde-cbn/extra-campo.*": "extra-campo",
  "^/tarde-cbn/na-trilha-da-politica.*": "na-trilha-da-politica",
  "^/tarde-cbn/onda-cultural.*": "onda-cultural",
  "^/tarde-cbn/precisamos-falar-sobre.*": "precisamos-falar-sobre",
  "^/tarde-cbn/voce-investe.*": "voce-investe",
  "^/cbn-esportes.*": "cbn-esportes",
  "^/podcasts.*": "podcasts",
  "^/ultimas.*": "ultimas",
  "^/cbn-goiania.*": "cbn-goiania",
  "^/tarde-cbn.*": "tarde-cbn",
} as const;

type TargetSlotsSection =
  | "Manchete sem foto CBN"
  | "Capa - fotão, secundárias e rodapé - CBNGO"
  | "Elemento - Jogos"
  | "Mais lidas"
  | "Últimas - Papo Político - Auto"
  | "Últimas Capa - CBNGO"
  | "Elementos - Radio CBNGO"
  | "CBN Goiânia - destaques"
  | "Tarde CBN - destaques"
  | "Café com CBN - destaques"
  | "Cenário Econômico com Leandro Resende"
  | "Na Ponta da Língua"
  | "Papo Político com Fabiana Pulcineli"
  | "Plural"
  | "Onda Cultural"
  | "Precisamos falar sobre"
  | "Você Investe"
  | "CBN + Esportes"
  | "Podcasts"
  | "Últimas CBN Goiânia - CBNGO"
  | "Últimas Tarde CBN - CBNGO"
  | "Últimas Café com CBN - CBNGO"
  | "Últimas CBN Talk - CBNGO"
  | "Últimas Boca e Baco - CBNGO"
  | "Últimas Cenário Econômico - CBNGO"
  | "Últimas Empreender - CBNGO"
  | "Leia também"
  | "Article Slot"
  | "Continue lendo / Mais Lidas"
  | "Últimas Guia Saúde - CBNGO"
  | "Últimas Na Ponta da Língua - CBNGO"
  | "Últimas Papo Político - CBNGO"
  | "Últimas Plural - CBNGO"
  | "Últimas Proseando - CBNGO"
  | "Últimas Rádio Pet - CBNGO"
  | "Últimas Divã na CBN - CBNGO"
  | "Últimas Extra Campo - CBNGO"
  | "Últimas Na Trilha da Política - CBNGO"
  | "Últimas Onda Cultural - CBNGO"
  | "Pesquisa - Lista"
  | "Search Filter"
  | "Search Slot"
  | "Últimas Precisamos falar Sobre - CBNGO" // publicidade legal
  | "Últimas Você Investe - CBNGO"
  | "Últimas CBN + Esportes - CBNGO"
  | "Podcasts - CBNGO"
  | "Expediente"
  | "Widget Agendamento"
  | "Matéria - Emprego"
  | "generic";

type SlotPositionType =
  | "BILL_MAXI1"
  | "LEADBRD1"
  | "LEADBRD2"
  | "LEADBRD3"
  | "MPAG1"
  | "MPAG2"
  | "MPAG3"
  | "RM1"
  | "RM2"
  | "RM3"
  | "BILL_MAXI1_M"
  | "RM1_M"
  | "RM2_M"
  | "RM3_M"
  | "MBOX1"
  | "MBOX2"
  | "MBOX3"
  | "MBOX?"
  | "RM?"
  | "MPAG?"
  | "LEADBRD?"
  | "RM?_M"
  | "HTML"
  | "";

type SlotIdCbnType =
  | "gjc_CBN.Home"
  | "gjc_CBN"
  | "gjc_CBN/Ultimas"
  | "gjc_CBN/CBN_Goiania"
  | "gjc_CBN/Tarde_CBN"
  | "gjc_CBN/Papo_Politico"
  | "gjc_CBN/Plural"
  | "gjc_CBN/Cenario_Economico"
  | "gjc_CBN/Na_Trilha_da_Politica"
  | "gjc_CBN/CBN_Esportes"
  | "gjc_CBN/Proseando"
  | "gjc_CBN/Na_Ponta_da_Lingua"
  | "gjc_CBN/Pesquisa"
  | "gjc_CBN/Voce_Investe"
  | "gjc_CBN/Precisamos_Falar_Sobre"
  | "gjc_CBN/Extra_Campo"
  | "gjc_CBN/Guia_Saude"
  | "gjc_CBN/Especial_Publicitario"
  | "gjc_CBN/Radio_Pet"
  | "gjc_CBN/Empreender"
  | "gjc_CBN/Boca_e_Baco"
  | "gjc_CBN/Diva_na_CBN"
  | "gjc_CBN/Onda_Cultural"
  | "gjc_CBN/Cafe_com_CBN"
  | "gjc_CBN/CBN_Talk"
  | "gjc_CBN/Podcasts"
  | "gjc_CBN.Ultimas"
  | "Alright"
  | "POP_INTERNAS_SMT_RM9999"
  | "POP_INTERNAS_DSK_MBOX9999";

type SectionName = typeof urlMapRegex[keyof typeof urlMapRegex];

type Slot = {
  id: SlotIdCbnType;
  position: SlotPositionType;
  nthPosition?: Array<Number>; //Slot potion by occurence, like 0, 1, 2, 3... The number represent when to be rendered by ocorrence
};

type DeviceSlotType = {
  desktopSlot?: Slot;
  mobileSlot?: Slot;
};

type PlacementType = {
  [placement in AdsSlotProps["componentReference"]]?: DeviceSlotType;
};

type BlockType = {
  [blockType in AdsSlotProps["type"]]?: PlacementType;
};

type AdsSettings = {
  [section in TargetSlotsSection]: {
    [subsection in SectionName | "*"]?: BlockType;
  };
};

const settings = {
  "Manchete sem foto CBN": {
    home: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Capa - fotão, secundárias e rodapé - CBNGO": {
    home: {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "RM1_M",
          },
        },
      },
    },
  },
  "Elemento - Jogos": {
    home: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Mais lidas": {
    home: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "RM2",
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "RM1_M",
          },
        },
      },
    },
  },
  "Últimas - Papo Político - Auto": {
    home: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "RM3",
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "RM2_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "RM3_M",
          },
        },
      },
    },
    'cbn-goiania': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas Capa - CBNGO": {
    home: {
      mega: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "LEADBRD2",
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
    ultimas: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Ultimas",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN.Ultimas",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN.Ultimas",
            position: "LEADBRD2",
          },
          mobileSlot: {
            id: "gjc_CBN.Ultimas",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },

  //ELEMENTO RÁDIO
  "Elementos - Radio CBNGO": {
    //EDITORIAS
    'cbn-goiania': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM2_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM3_M",
          },
        },
      },
    },
    'tarde-cbn': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "RM2_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "RM3_M",
          },
        },
      },
    },
    //SUB EDITORIAS
    'cafe-com-cbn': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "RM3_M",
          },
        },
      },
    },
    'cbn-talk': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "RM3_M",
          },
        },
      },
    },
    'boca-baco': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "RM3_M",
          },
        },
      },
    },
    'cenario-economico': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "RM3_M",
          },
        },
      },
    },
    'empreender': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "RM3_M",
          },
        },
      },
    },
    'guia-saude': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "RM3_M",
          },
        },
      },
    },
    'napontadalingua': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "RM3_M",
          },
        },
      },
    },
    'papo-politico': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "RM3_M",
          },
        },
      },
    },
    'plural': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Plural",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Plural",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Plural",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Plural",
            position: "RM3_M",
          },
        },
      },
    },
    'proseando': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Proseando",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Proseando",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Proseando",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Proseando",
            position: "RM3_M",
          },
        },
      },
    },
    'radio-pet': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/gjc_CBN/Radio_Pet",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/gjc_CBN/Radio_Pet",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/gjc_CBN/Radio_Pet",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/gjc_CBN/Radio_Pet",
            position: "RM3_M",
          },
        },
      },
    },
    'diva-na-cbn': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "RM3_M",
          },
        },
      },
    },
    'extra-campo': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "RM3_M",
          },
        },
      },
    },
    'na-trilha-da-politica': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "RM3_M",
          },
        },
      },
    },
    'onda-cultural': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "RM3_M",
          },
        },
      },
    },
    'precisamos-falar-sobre': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "RM3_M",
          },
        },
      },
    },
    'voce-investe': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "RM3_M",
          },
        },
      },
    },
    'cbn-esportes': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "RM3_M",
          },
        },
      },
    },
    'ultimas': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Ultimas",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN/Ultimas",
            position: "RM1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "MPAG1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "RM3_M",
          },
        },
      },
    },
  },

  //DESTAQUE CAPAS EDITORIAS
  "CBN Goiânia - destaques": {
    'cbn-goiania': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Tarde CBN - destaques": {
    'tarde-cbn': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },

  //DESTAQUES SUB EDITORIAS
  "Café com CBN - destaques": {
    'cbn-goiania': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cafe_com_CBN",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Cafe_com_CBN",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Cenário Econômico com Leandro Resende": {
    'cenario-economico': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Na Ponta da Língua": {
    'napontadalingua': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Papo Político com Fabiana Pulcineli": {
    'papo-politico': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Plural": {
    'plural': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Plural",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Plural",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Proseando com José Bonfim": {
    'proseando': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Proseando",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Proseando",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Rádio Pet": {
    'radio-pet': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Divã na CBN": {
    'diva-na-cbn': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Na Trilha da Política com Cileide Alves": {
    'na-trilha-da-politica': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Onda Cultural": {
    'onda-cultural': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Precisamos falar sobre": {
    'precisamos-falar-sobre': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Você Investe": {
    'voce-investe': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "CBN + Esportes": {
    'cbn-esportes': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },
  "Podcasts": {
    'podcasts': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Podcasts",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Podcasts",
            position: "BILL_MAXI1_M",
          },
        },
      },
    },
  },

  //ULTIMAS CAPAS EDITORIAS
  "Últimas CBN Goiânia - CBNGO": {
    'cbn-goiania': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM3_M",
          },
        },
      },
    },
  },
  "Últimas Tarde CBN - CBNGO": {
    'tarde-cbn': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "RM3_M",
          },
        },
      },
    },
  },

  //SULTIMAS SUB EDITORIAS
  "Últimas Café com CBN - CBNGO": {
    'cbn-goiania': {
      mega: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM3_M",
          },
        },
      },
    },
  },
  "Últimas CBN Talk - CBNGO": {
    'cbn-talk': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "BILL_MAXI1_M",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "RM3_M",
          },
        },
      },
    },
  },
  "Últimas Boca e Baco - CBNGO": {
    'boca-baco': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "RM3_M",
          },
        },
      },
    },
  },
  "Últimas Cenário Econômico - CBNGO": {
    'cenario-economico': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas Empreender - CBNGO": {
    'empreender': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Empreender",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Empreender",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Empreender",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Empreender",
            position: "RM3_M",
          },
        },
      },
    },
  },
  "Últimas Guia Saúde - CBNGO": {
    'guia-saude': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "RM3_M",
          },
        },
      },
    },
  },
  "Últimas Na Ponta da Língua - CBNGO": {
    'napontadalingua': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas Papo Político - CBNGO": {
    'papo-politico': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas Plural - CBNGO": {
    'plural': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Plural",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Plural",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas Proseando - CBNGO": {
    'proseando': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Proseando",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Proseando",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas Rádio Pet - CBNGO": {
    'radio-pet': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas Divã na CBN - CBNGO": {
    'diva-na-cbn': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas Extra Campo - CBNGO": {
    'extra-campo': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "RM3_M",
          },
        },
      },
    },
  },
  "Últimas Na Trilha da Política - CBNGO": {
    'na-trilha-da-politica': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas Onda Cultural - CBNGO": {
    'onda-cultural': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas Precisamos falar Sobre - CBNGO": {
    'precisamos-falar-sobre': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas Você Investe - CBNGO": {
    'voce-investe': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Últimas CBN + Esportes - CBNGO": {
    'cbn-esportes': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Podcasts - CBNGO": {
    'podcasts': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Podcasts",
            position: "LEADBRD1",
          },
          mobileSlot: {
            id: "gjc_CBN/Podcasts",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Pesquisa - Lista": {
    pesquisa: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Pesquisa",
            position: "BILL_MAXI1",
          },
          mobileSlot: {
            id: "gjc_CBN/Pesquisa",
            position: "BILL_MAXI1_M",
          },
        },
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Pesquisa",
            position: "LEADBRD1",
          },
        },
      },
    },
  },
  "Search Filter": {
    "*": {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN",
            position: "RM1",
          },
          mobileSlot: {
            id: "gjc_CBN",
            position: "RM2_M",
          },
        },
      },
    },
  },
  "Search Slot": {
    "*": {
      search: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN",
            position: "MBOX1",
          },
          mobileSlot: {
            id: "gjc_CBN",
            position: "RM1_M",
          },
        },
      },
    },
  },
  //CONTINUE LENDO / MAIS LIDAS MATÉRIAS
  "Continue lendo / Mais Lidas": {
    home: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "MPAG1",
          },
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "RM2",
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "RM2_M",
          },
        },
      },
    },
    "cbn-goiania": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "MPAG1",
          },
        },
      },
    },
    "tarde-cbn": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "MPAG1",
          },
        },
      },
    },
    "boca-baco": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "MPAG1",
          },
        },
      },
    },
    "cafe-com-cbn": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cafe_com_CBN",
            position: "MPAG1",
          },
        },
      },
    },
    "cbn-talk": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "MPAG1",
          },
        },
      },
    },
    "cenario-economico": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "MPAG1",
          },
        },
      },
    },
    "empreender": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Empreender",
            position: "MPAG1",
          },
        },
      },
    },
    "guia-saude": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "MPAG1",
          },
        },
      },
    },
    "napontadalingua": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "MPAG1",
          },
        },
      },
    },
    "papo-politico": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "MPAG1",
          },
        },
      },
    },
    "plural": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Plural",
            position: "MPAG1",
          },
        },
      },
    },
    "proseando": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Proseando",
            position: "MPAG1",
          },
        },
      },
    },
    "radio-pet": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "MPAG1",
          },
        },
      },
    },
    "extra-campo": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "MPAG1",
          },
        },
      },
    },
    "diva-na-cbn": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "MPAG1",
          },
        },
      },
    },
    "na-trilha-da-politica": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "MPAG1",
          },
        },
      },
    },
    "onda-cultural": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "MPAG1",
          },
        },
      },
    },
    "precisamos-falar-sobre": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "MPAG1",
          },
        },
      },
    },
    "voce-investe": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "MPAG1",
          },
        },
      },
    },
    "cbn-esportes": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "MPAG1",
          },
        },
      },
    },
    "podcasts": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Podcasts",
            position: "MPAG1",
          },
        },
      },
    },
    "ultimas": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Ultimas",
            position: "MPAG1",
          },
        },
      },
    },
  },
  "Matéria - genérica - CBNGO": {
    "*": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Article Slot": {
    "*": {
      article: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN",
            position: "MBOX?",
          },
          mobileSlot: {
            id: "gjc_CBN",
            position: "RM?_M",
          },
        },
      },
    },
  },
  "generic": {
      "*": {
          "article": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
          "block": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
          "mega": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
          "side": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
          "search": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
          "newsletter": {
              "top": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              },
              "bottom": {
                  "desktopSlot": {
                      "id": "POP_INTERNAS_DSK_MBOX9999",
                      "position": ""
                  },
                  "mobileSlot": {
                      "id": "POP_INTERNAS_SMT_RM9999",
                      "position": ""
                  }
              }
          },
      }
  },
};

type SlotSizes = {
  [slotName: string]: [number, number];
};

type SlotSizeMap = {
  [key in SlotIdCbnType]?: SlotSizes;
};

const slotSizeMap: SlotSizeMap = {
  "gjc_CBN.Home": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Proseando": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Na_Ponta_da_Lingua": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Tarde_CBN": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Cenario_Economico": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/CBN_Goiania": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Voce_Investe": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/CBN_Esportes": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Plural": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Papo_Politico": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Pesquisa": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Na_Trilha_da_Politica": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Precisamos_Falar_Sobre": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Ultimas": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Extra_Campo": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Guia_Saude": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

    "gjc_CBN/Especial_Publicitario": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Radio_Pet": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Empreender": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Boca_e_Baco": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Diva_na_CBN": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Onda_Cultural": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Cafe_com_CBN": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/CBN_Talk": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN/Podcasts": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  "gjc_CBN.Ultimas": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
};

const AdsSlot: React.FC<AdsSlotProps> = ({
  type,
  componentReference = "bottom",
  data,
}) => {
  return (
    <AdsSlotEngine
      settings={settings}
      urlMapRegex={urlMapRegex}
      slotSizeMap={slotSizeMap}
      type={type}
      componentReference={componentReference}
      data={data}
    />
  );
};

export default AdsSlot;
